package org.hs_soft.runmynesto.di

import org.koin.core.context.GlobalContext


val GlobalKoin=GlobalContext.get()